import PropTypes from 'prop-types';
import React from 'react';

import { ApiProvider, EventType } from './components/ApiClientsContext';
import { ErrorProvider } from './components/ErrorContext';
import { LocationProvider } from './components/LocationContext';
import { MemberProvider } from './components/MemberContext';
import { AnalyticsProps, TrackingProvider } from './components/TrackingContext';
import { ScheduleOfEventsForm, SoEFormProps } from './ScheduleOfEvents';

interface SoEProps extends SoEFormProps {
  baseAnalyticsProps?: AnalyticsProps;
}

export const ScheduleOfEventsModal: React.FC<SoEProps> = ({ baseAnalyticsProps = {}, ...rest }) => {
  return (
    <ErrorProvider>
      <ApiProvider>
        <MemberProvider>
          <LocationProvider>
            <TrackingProvider baseProps={baseAnalyticsProps}>
              <ScheduleOfEventsForm {...rest} />
            </TrackingProvider>
          </LocationProvider>
        </MemberProvider>
      </ApiProvider>
    </ErrorProvider>
  );
};

ScheduleOfEventsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setClose: PropTypes.func.isRequired,
  weddingId: PropTypes.string.isRequired,
  type: PropTypes.oneOf<EventType>(['WeddingEvent', 'WeddingDay']).isRequired,
  event: PropTypes.oneOfType([PropTypes.object]),
  hasWWS: PropTypes.bool.isRequired,
  hideDate: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
  onHideDate: PropTypes.func.isRequired,
  autoFillEventProperties: PropTypes.oneOfType([PropTypes.object]),
  isExperiment: PropTypes.bool,
  preview: PropTypes.bool,
  overlay: PropTypes.bool,
};

ScheduleOfEventsModal.defaultProps = {
  event: null,
  hideDate: false,
  autoFillEventProperties: {},
  isExperiment: false,
  preview: false,
  overlay: true,
};
